
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"14","height":"14","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M13 7A6 6 0 111 7a6 6 0 0112 0z"}}),_c('path',{attrs:{"d":"M6.218 8.673a.6.6 0 001.2 0h-1.2zm1.2 1.2a.6.6 0 00-1.2 0h1.2zm-1.2.136a.6.6 0 101.2 0h-1.2zM4.815 6.182a.6.6 0 001.2 0h-1.2zm2.236-1.31h.037v-1.2H7.05v1.2zm1.037 1v.105h1.2v-.104h-1.2zm-1.87 1.975v.826h1.2v-.826h-1.2zm0 2.026v.136h1.2v-.136h-1.2zM4.815 5.909v.273h1.2v-.273h-1.2zm2.377.964a.974.974 0 00-.974.974h1.2a.226.226 0 01-.226.226v-1.2zm.896-.896a.896.896 0 01-.896.896v1.2a2.096 2.096 0 002.096-2.096h-1.2zm-1-1.104a1 1 0 011 1h1.2a2.2 2.2 0 00-2.2-2.2v1.2zm-.037-1.2a2.236 2.236 0 00-2.236 2.236h1.2c0-.572.464-1.036 1.036-1.036v-1.2z","fill":"#585858"}})])
          )
        }
      }
    